module.exports = __webpack_public_path__ + "img/truck-tow.ff5309c9.svg";